import { Box,Heading,Text } from "@chakra-ui/react";
import React from "react";

export default function WorkForYou() {
  return (
    <Box data-aos="fade-up" id="deal" mb="12%">
      <Heading>Learn how we work for you</Heading>
      <Text lineHeight={"10"} color={"text"}>
        Talk to sales today
      </Text>
    </Box>
  );
}
